/* ══════════════════════════════════════════════════════════════
   33Fuel — AG1 Alternative landing page
   Upload to:  Assets  →  ag1-alt.js

   • Variant IDs, prices and Loop selling plans come from
     /products/<handle>.js (the only endpoint exposing
     selling_plan_allocations).
   • Add to cart goes through XMLHttpRequest, because cart apps
     (OCU) patch XHR to detect adds — that is what makes the app
     drawer refresh and open itself with the new line in it.
   • Prices are formatted in the buyer's own currency — see money()
     below. Shopify Markets converts the numbers; we must not
     hardcode the symbol.
   • Stuck? Open the page, press F12 and run:  F33_DEBUG()
   ══════════════════════════════════════════════════════════════ */

(function(){
  function init(){

  var d = document;
  var $  = function(s){ return d.querySelector(s); };
  var $$ = function(s){ return Array.prototype.slice.call(d.querySelectorAll(s)); };

  /* ── Scroll reveal ─────────────────────────────────────────────── */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('f33-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    $$('.f33-reveal').forEach(function(el){ io.observe(el); });
  } else {
    $$('.f33-reveal').forEach(function(el){ el.classList.add('f33-in'); });
  }

  /* ── FAQ accordion ─────────────────────────────────────────────── */
  $$('.f33-q button').forEach(function(b){
    b.addEventListener('click', function(){
      var q = b.parentElement,
          a = q.querySelector('.f33-a'),
          open = q.classList.contains('f33-open');
      $$('.f33-q').forEach(function(x){
        x.classList.remove('f33-open');
        var xa = x.querySelector('.f33-a');
        if (xa) xa.style.maxHeight = null;
      });
      if (!open && a) { q.classList.add('f33-open'); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });

  /* ── Reviews tabs ──────────────────────────────────────────────── */
  $$('.f33-rev-tab').forEach(function(t){
    t.addEventListener('click', function(){
      var i = t.dataset.tab;
      $$('.f33-rev-tab').forEach(function(x){ x.classList.toggle('f33-active', x === t); });
      $$('.f33-rev-page').forEach(function(p){ p.classList.toggle('f33-active', p.dataset.page === i); });
    });
  });

  /* ═══════════════════════════════════════════════════════════════
     ▸ CONFIG
     ═══════════════════════════════════════════════════════════════ */

  var PRODUCT_HANDLE = "ultimate-greens-powder";
  var PRODUCT_URL    = "/products/" + PRODUCT_HANDLE;

  var SIZE_OPTION = "1 Pack - 30 serve";   // option2 sold on this page
  var PLAN_MATCH  = "";                    // "" = cheapest Loop plan, or e.g. "4 week"
  var SUB_FALLBACK = "product";            // "product" | "onetime" — if no Loop plan

  // ▸ HOW THE ADD REQUEST IS SENT
  //  "xhr"   → XMLHttpRequest (cart apps patch this — use it with OCU)
  //  "fetch" → fetch()
  var ADD_METHOD = "xhr";

  // ▸ CART OPENING
  //  "app"   → the cart app's drawer (OCU)
  //  "theme" → the theme's native drawer
  //  "page"  → always /cart
  //  "none"  → do nothing
  var CART_MODE = "app";

  var CART_APP_SELECTOR   = ".ocu-cart-drawer";
  var CART_APP_OPEN_CLASS = "ocu-visible";

  // How long to wait for the app drawer to open by ITSELF before nudging it.
  var CART_APP_SELF_WAIT_MS = 1200;
  // How long to wait after the nudge before giving up entirely.
  var CART_APP_WAIT_MS = 2500;

  // What to do if the app drawer doesn't open by itself.
  //  "click" → click the cart button (the app then loads a fresh cart)
  //  "page"  → go to /cart
  //  "none"  → do nothing
  var CART_FALLBACK = "click";

  // Only used when CART_FALLBACK = "click". "" = auto-detect.
  // Your theme (Archetype family — Impulse / Streamline) uses this one.
  var CART_TRIGGER = ".js-drawer-open-cart";

  // Close the theme's own drawer if it opens alongside the app drawer.
  // Leave the selectors empty for auto-detection, or paste yours — run
  // F33_DEBUG() while BOTH drawers are open and look at "openPanels".
  var CLOSE_THEME_DRAWER = true;
  var THEME_DRAWER_SELECTOR = "#CartDrawer";
  var THEME_DRAWER_CLOSE_SELECTOR = "#CartDrawer .js-drawer-close";

  // Archetype themes open a drawer by putting a class on <body>, not on the
  // drawer element — this is what has to be removed to shut it.
  // NOTE: scroll-lock classes are deliberately NOT listed; the app drawer
  // needs them while it is open.
  var THEME_BODY_OPEN_CLASSES = [
    'js-drawer-open', 'js-drawer-open-right', 'js-drawer-open-left',
    'drawer-open', 'cart-open', 'js-drawer-open-button-right'
  ];

  // Fallback variant IDs, used only until /products/*.js resolves
  var FLAVOURS = {
    original:  { label:"Original",   option:"Original",  variant:"35387302281373", plan:"" },
    mint:      { label:"Fresh Mint", option:"Mint",      variant:"56091188560251", plan:"" },
    raspberry: { label:"Raspberry",  option:"Raspberry", variant:"55229722165627", plan:"" },
    orange:    { label:"Orange",     option:"Orange",    variant:"55229722100091", plan:"" }
  };

  var PRICE = { sub: 28.47, onetime: 33.49 };

  /* ═══════════════════════════════════════════════════════════════
     ▸ Product data
     ═══════════════════════════════════════════════════════════════ */

  var plansFound = 0;
  var dataSource = "fallback";
  var lastAjaxProduct = null;

  function applyVariant(f, id, priceCents, available, allocations, planNames){
    f.variant   = String(id);
    f.available = available !== false;
    f.price     = priceCents / 100;

    var plans = (allocations || []).map(function(a){
      return {
        id: a.selling_plan_id != null ? a.selling_plan_id : a.id,
        price: a.price,
        name: (a.name != null ? a.name : (planNames && planNames[a.selling_plan_id]) || "")
      };
    }).filter(function(p){ return p.id; });

    var chosen = null;
    if (PLAN_MATCH) {
      chosen = plans.filter(function(p){
        return (p.name || '').toLowerCase().indexOf(PLAN_MATCH.toLowerCase()) > -1;
      })[0] || null;
    }
    if (!chosen && plans.length) {
      chosen = plans.slice().sort(function(a,b){ return a.price - b.price; })[0];
    }
    if (chosen) {
      f.plan     = String(chosen.id);
      f.planName = chosen.name;
      f.subPrice = chosen.price / 100;
      plansFound++;
    }
    f.allPlans = plans;
  }

  (function hydrateFromLiquid(){
    var P = window.F33_PRODUCT;
    if (!P || !P.variants || !P.variants.length) return;
    dataSource = "liquid";
    Object.keys(FLAVOURS).forEach(function(key){
      var f = FLAVOURS[key];
      var v = P.variants.filter(function(x){
        return x.flavour === f.option && x.size === SIZE_OPTION;
      })[0];
      if (!v) return;
      applyVariant(f, v.id, v.price, v.available, (v.plans || []).map(function(p){
        return { selling_plan_id: p.id, price: p.price, name: p.name };
      }));
    });
    syncBasePrice();
  })();

  var productPromise = null;
  function loadProduct(){
    if (productPromise) return productPromise;
    productPromise = fetch(PRODUCT_URL + '.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
    .then(function(r){ return r.json(); })
    .then(function(p){
      if (!p || !p.variants) return null;
      lastAjaxProduct = p;

      var planNames = {};
      (p.selling_plan_groups || []).forEach(function(g){
        (g.selling_plans || []).forEach(function(sp){ planNames[sp.id] = sp.name; });
      });

      plansFound = 0;
      Object.keys(FLAVOURS).forEach(function(key){
        var f = FLAVOURS[key];
        var v = p.variants.filter(function(x){
          var o = x.options || [];
          var o1 = x.option1 != null ? x.option1 : o[0];
          var o2 = x.option2 != null ? x.option2 : o[1];
          return o1 === f.option && o2 === SIZE_OPTION;
        })[0];
        if (!v) return;
        applyVariant(f, v.id, v.price, v.available, v.selling_plan_allocations, planNames);
      });

      dataSource = "ajax";
      syncBasePrice();
      renderTotal();
      if (!plansFound && window.console) {
        console.error('[33Fuel LP] No Loop selling plan found. Run F33_DEBUG().');
      }
      return p;
    })
    .catch(function(err){
      window.console && console.warn('[33Fuel LP] product .js fetch failed:', err);
      return null;
    });
    return productPromise;
  }

  function syncBasePrice(){
    var base = FLAVOURS.original;
    if (base.price)    PRICE.onetime = base.price;
    if (base.subPrice) PRICE.sub     = base.subPrice;
  }

  loadProduct();

  /* ═══════════════════════════════════════════════════════════════
     ▸ Buy module — markup and behaviour unchanged, prices dynamic
     ═══════════════════════════════════════════════════════════════ */

  var state = { flav:"original", mode:"sub", qty:1 };

  /* ── Money formatting ──────────────────────────────────────────────
     Shopify Markets already converts the NUMBERS (both the Liquid
     F33_PRODUCT block and /products/*.js come back in the buyer's
     presentment currency), so a hardcoded "£" was the only thing
     making a US or EU visitor see "£36.10" instead of "$36.10".

     The active currency is stamped on every page by Shopify itself:
       window.Shopify.currency = {"active":"GBP","rate":"1.0"}
     …so we read it at runtime and let Intl pick the right symbol.
     That keeps this file cacheable — nothing here is baked per market.

     currencyDisplay:'narrowSymbol' gives "$36.10" rather than
     "US$36.10". Drop that option (or append " " + MONEY_CODE) if you
     would rather disambiguate USD / CAD / AUD for the buyer.
     Both fallbacks matter: older Safari throws on narrowSymbol, and
     anything without Intl falls back to the old £ behaviour.
     ─────────────────────────────────────────────────────────────── */
  var MONEY_CODE = (function(){
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        return Shopify.currency.active;
      }
    } catch(e){}
    return 'GBP';
  })();

  var MONEY_LOCALE = d.documentElement.lang || 'en-GB';

  var moneyFormatter = (function(){
    if (typeof Intl === 'undefined' || !Intl.NumberFormat) return null;
    try {
      return new Intl.NumberFormat(MONEY_LOCALE, {
        style: 'currency', currency: MONEY_CODE, currencyDisplay: 'narrowSymbol'
      });
    } catch(e){}
    try {
      return new Intl.NumberFormat(MONEY_LOCALE, { style: 'currency', currency: MONEY_CODE });
    } catch(e){}
    return null;
  })();

  var money = function(n){
    var v = Number(n) || 0;
    return moneyFormatter ? moneyFormatter.format(v) : '£' + v.toFixed(2);
  };

  function priceFor(mode){
    var f = FLAVOURS[state.flav];
    if (mode === "sub")  return (f.subPrice != null ? f.subPrice : PRICE.sub);
    return (f.price != null ? f.price : PRICE.onetime);
  }

  function renderPrices(){
    var subB = $("#f33SubPrice"), subS = $("#f33SubCompare"), oneB = $("#f33OnePrice");
    if (oneB) oneB.textContent = money(priceFor("onetime"));
    if (subB) subB.textContent = money(priceFor("sub"));
    if (subS) subS.textContent = money(priceFor("onetime"));
  }

  function renderTotal(){
    var total = $("#bbTotal");
    if (total) total.textContent = money(priceFor(state.mode) * state.qty);
    renderPrices();
    syncSticky();
  }

  function syncSticky(){
    var meta = $("#scaMeta"), price = $("#scaPrice");
    if (!meta || !price) return;
    var flavLabel = FLAVOURS[state.flav].label;
    if (state.mode === "sub"){
      meta.innerHTML = flavLabel + ' · Subscribe &amp; Save · <em>save 15%</em> &nbsp;<span class="f33-sca-change">Change</span>';
    } else {
      meta.innerHTML = flavLabel + ' · One-time purchase &nbsp;<span class="f33-sca-change">Change</span>';
    }
    price.textContent = money(priceFor(state.mode) * state.qty);
  }

  $$('#bbFlavs .f33-flav-opt').forEach(function(el){
    el.addEventListener('click', function(){
      $$('#bbFlavs .f33-flav-opt').forEach(function(x){ x.classList.remove('f33-sel'); });
      el.classList.add('f33-sel');
      state.flav = el.dataset.flav;
      renderTotal();
    });
  });

  $$('#bbModes .f33-mode').forEach(function(el){
    el.addEventListener('click', function(){
      $$('#bbModes .f33-mode').forEach(function(x){ x.classList.remove('f33-sel'); });
      el.classList.add('f33-sel');
      state.mode = el.dataset.mode;
      renderTotal();
    });
  });

  var qMinus = $("#qtyMinus"), qPlus = $("#qtyPlus"), qInput = $("#qtyInput");
  if (qMinus && qInput) qMinus.addEventListener('click', function(){
    state.qty = Math.max(1, state.qty - 1); qInput.value = state.qty; renderTotal();
  });
  if (qPlus && qInput) qPlus.addEventListener('click', function(){
    state.qty = Math.min(12, state.qty + 1); qInput.value = state.qty; renderTotal();
  });
  if (qInput) qInput.addEventListener('change', function(e){
    var v = parseInt(e.target.value, 10) || 1;
    v = Math.max(1, Math.min(12, v));
    state.qty = v; e.target.value = v; renderTotal();
  });

  /* ═══════════════════════════════════════════════════════════════
     ▸ Cart drawer
     ═══════════════════════════════════════════════════════════════ */

  var CART_LINK_SELECTORS = [
    '#cart-icon-bubble', '.header__icon--cart', '.site-header__cart',
    '.js-drawer-open-right', '.cart-link', '[data-cart-drawer-toggle]',
    'a[href="/cart"]', 'a[href^="/cart?"]', 'a[href$="/cart"]'
  ].join(',');

  function appDrawer(){ return CART_APP_SELECTOR ? d.querySelector(CART_APP_SELECTOR) : null; }
  function appDrawerOpen(){
    var el = appDrawer();
    return !!(el && el.classList.contains(CART_APP_OPEN_CLASS));
  }

  // Everything that looks like a cart drawer but is NOT the app's own one.
  function themeDrawers(){
    var sel = THEME_DRAWER_SELECTOR || [
      'cart-drawer', '#CartDrawer', '[id*="cart-drawer"]',
      '[class*="cart-drawer"]', '[class*="cart_drawer"]',
      '[class*="mini-cart"]', '[class*="minicart"]',
      '[class*="drawer"][class*="cart"]'
    ].join(',');
    var found = [];
    try { found = $$(sel); } catch(e){ return []; }
    return found.filter(function(el){
      if (el.closest && el.closest(CART_APP_SELECTOR)) return false;      // the app's own
      if (String(el.className || '').indexOf('ocu-') > -1) return false;  // the app's own
      return true;
    });
  }

  function themeDrawerIsOpen(){
    var cl = d.body.classList;
    for (var i = 0; i < THEME_BODY_OPEN_CLASSES.length; i++){
      if (cl.contains(THEME_BODY_OPEN_CLASSES[i])) return true;
    }
    return themeDrawers().some(function(el){
      return /(^|\s)(is-open|active|drawer--open|is-visible)(\s|$)/.test(el.className || '');
    });
  }

  function closeThemeDrawersOnce(){
    if (!themeDrawerIsOpen()) return;

    // 1) the theme's own API, if it exposes one
    var t = window.theme;
    if (t){
      ['cartDrawer','CartDrawer','cart'].forEach(function(k){
        if (t[k] && typeof t[k].close === 'function'){ try { t[k].close(); } catch(e){} }
      });
    }

    // 2) the drawer's own close button — the cleanest way, it unwinds
    //    whatever state the theme set
    if (THEME_DRAWER_CLOSE_SELECTOR){
      var btn = d.querySelector(THEME_DRAWER_CLOSE_SELECTOR);
      if (btn && !(btn.closest && btn.closest(CART_APP_SELECTOR))){
        try { btn.click(); } catch(e){}
      }
    }

    // 3) strip the body/html classes the theme uses to reveal the drawer
    THEME_BODY_OPEN_CLASSES.forEach(function(c){
      d.body.classList.remove(c);
      d.documentElement.classList.remove(c);
    });

    // 4) and any open-state class left on the drawer element itself
    themeDrawers().forEach(function(el){
      if (typeof el.close === 'function'){ try { el.close(); } catch(e){} }
      var inner = el.querySelector('.js-drawer-close, .drawer__close, [data-drawer-close], button[aria-label="Close"]');
      if (inner && !(inner.closest && inner.closest(CART_APP_SELECTOR))){
        try { inner.click(); } catch(e){}
      }
      el.classList.remove('active','is-open','open','animate','drawer--open','is-visible','visible');
    });
  }

  // Runs on every animation frame for the first second, so the theme's drawer
  // is shut on the next frame after it opens and never really paints.
  function suppressThemeDrawer(durationMs){
    if (!CLOSE_THEME_DRAWER) return;
    var until = Date.now() + (durationMs || 2500);
    var rafUntil = Date.now() + 1200;

    (function frame(){
      closeThemeDrawersOnce();
      if (Date.now() < rafUntil) requestAnimationFrame(frame);
    })();

    var t = setInterval(function(){
      closeThemeDrawersOnce();
      if (Date.now() > until) clearInterval(t);
    }, 100);
  }

  // Poll by RE-QUERYING the DOM each tick. The app re-mounts its drawer node,
  // so an observer bound to one element misses it — that was the bug.
  function whenAppDrawerOpens(timeoutMs, onOpen, onTimeout){
    if (appDrawerOpen()){ onOpen && onOpen(); return; }
    var start = Date.now();
    var t = setInterval(function(){
      if (appDrawerOpen()){ clearInterval(t); onOpen && onOpen(); return; }
      if (Date.now() - start > timeoutMs){ clearInterval(t); onTimeout && onTimeout(); }
    }, 60);
  }

  // ▸ THE CLEAN PATH — Zipify OCU's documented public API.
  //   openUpdatedCart() reloads the cart and opens OCU's drawer without
  //   going anywhere near the theme, so the theme's own drawer can never
  //   be woken up. Docs: github.com/ZipifyApps/ocu/wiki/Public-API
  function zipifyCart(){
    try {
      var c = window.Zipify && window.Zipify.Cart && window.Zipify.Cart.instance;
      return (c && (typeof c.openUpdatedCart === 'function' || typeof c.openCart === 'function')) ? c : null;
    } catch(e){ return null; }
  }

  function openCart(){
    if (CART_MODE === 'none') return;
    if (CART_MODE === 'page'){ window.location.href = '/cart'; return; }

    var zc = zipifyCart();
    if (CART_MODE === 'app' && zc){
      try {
        if (typeof zc.openUpdatedCart === 'function') zc.openUpdatedCart();
        else { if (typeof zc.updateCart === 'function') zc.updateCart(); zc.openCart(); }
      } catch(e){
        window.console && console.warn('[33Fuel LP] Zipify openUpdatedCart failed:', e);
      }
      // safety net only — if the app drawer never appears, don't strand anyone
      whenAppDrawerOpens(CART_APP_WAIT_MS, null, function(){
        if (!appDrawerOpen()) window.location.href = '/cart';
      });
      return;
    }

    if (CART_MODE === 'app' && appDrawer()){
      suppressThemeDrawer(3000);

      whenAppDrawerOpens(CART_APP_SELF_WAIT_MS,
        function(){ suppressThemeDrawer(1500); },
        function(){
          // The app didn't open itself — nudge it with a real click, which
          // also makes it reload the cart so the new line is there.
          if (CART_FALLBACK === 'none') return;
          if (CART_FALLBACK === 'page'){ window.location.href = '/cart'; return; }

          var trigger = CART_TRIGGER ? d.querySelector(CART_TRIGGER)
                                     : d.querySelector(CART_LINK_SELECTORS);
          if (!trigger){ window.location.href = '/cart'; return; }

          suppressThemeDrawer(3000);
          try { trigger.click(); } catch(e){}
          whenAppDrawerOpens(CART_APP_WAIT_MS,
            function(){ suppressThemeDrawer(1500); },
            function(){ window.location.href = '/cart'; }
          );
        }
      );
      return;
    }

    var native = d.querySelector('cart-drawer');
    if (native){
      fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then(function(r){ return r.json(); })
        .then(function(sections){
          native.classList.remove('is-empty');
          if (typeof native.renderContents === 'function') native.renderContents({ sections: sections });
          else if (typeof native.open === 'function') native.open();
        })
        .catch(function(){ if (native.open) native.open(); });
      return;
    }

    var link = d.querySelector(CART_LINK_SELECTORS);
    if (link) { link.click(); return; }
    window.location.href = '/cart';
  }

  /* ── Add to cart ───────────────────────────────────────────────── */

  var busy = false;
  var buttons = [];

  function setBusy(on, msg){
    busy = on;
    buttons.forEach(function(b){
      if (!b) return;
      if (on){
        if (!b.dataset.f33Label) b.dataset.f33Label = b.innerHTML;
        b.innerHTML = msg || 'Adding…';
        b.classList.add('f33-busy');
        b.disabled = true;
      } else {
        if (b.dataset.f33Label) b.innerHTML = b.dataset.f33Label;
        b.classList.remove('f33-busy');
        b.disabled = false;
      }
    });
  }

  // XHR, not fetch — cart apps hook XMLHttpRequest to spot /cart/add.js
  function postToCart(f){
    var item = { id: Number(f.variant), quantity: state.qty };
    if (state.mode === 'sub' && f.plan) item.selling_plan = Number(f.plan);
    var payload = JSON.stringify({ items: [ item ] });

    if (ADD_METHOD !== 'xhr'){
      return fetch('/cart/add.js', {
        method:'POST', credentials:'same-origin',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: payload
      }).then(function(r){
        return r.json().then(function(j){
          if (!r.ok) throw new Error(j.description || j.message || 'Cart error');
          return j;
        });
      });
    }

    return new Promise(function(resolve, reject){
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = function(){
        var body = {};
        try { body = JSON.parse(xhr.responseText); } catch(e){}
        if (xhr.status >= 200 && xhr.status < 300) resolve(body);
        else reject(new Error(body.description || body.message || ('HTTP ' + xhr.status)));
      };
      xhr.onerror = function(){ reject(new Error('Network error')); };
      xhr.send(payload);
    });
  }

  function addToCart(){
    if (busy) return;
    setBusy(true);

    var f = FLAVOURS[state.flav];
    if (!f || !f.variant){ window.location.href = PRODUCT_URL; return; }

    var ready = (state.mode === 'sub' && !f.plan) ? loadProduct() : Promise.resolve(null);

    ready.then(function(){
      f = FLAVOURS[state.flav];

      if (state.mode === 'sub' && !f.plan){
        setBusy(false);
        window.console && console.error('[33Fuel LP] No Loop plan for ' + f.label + ' — see F33_DEBUG()');
        if (SUB_FALLBACK === 'product'){
          window.location.href = PRODUCT_URL + '?variant=' + f.variant;
          return;
        }
        setBusy(true);
      }

      return postToCart(f).then(function(){
        setBusy(false);
        openCart();
      });
    })
    .catch(function(err){
      setBusy(false);
      window.console && console.warn('[33Fuel LP] add failed:', err);
      var url = '/cart/add?id=' + f.variant + '&quantity=' + state.qty;
      if (state.mode === 'sub' && f.plan) url += '&selling_plan=' + f.plan;
      window.location.href = url;
    });
  }

  var bbAdd = $("#bbAdd"), scaAdd = $("#scaAdd");
  buttons = [bbAdd, scaAdd];
  if (bbAdd)  bbAdd.addEventListener('click', addToCart);
  if (scaAdd) scaAdd.addEventListener('click', addToCart);

  $$('.f33-jump-buy').forEach(function(el){
    el.addEventListener('click', function(e){
      var bb = d.getElementById('buybox');
      if (!bb) return;
      e.preventDefault();
      bb.scrollIntoView({ behavior:'smooth', block:'center' });
    });
  });

  var scaProd = $("#scaProd");
  if (scaProd) scaProd.addEventListener('click', function(){
    var bb = d.getElementById('buybox');
    if (bb) bb.scrollIntoView({ behavior:'smooth', block:'center' });
  });

  renderTotal();

  /* ── Sticky buy bar ────────────────────────────────────────────── */
  var sticky   = d.getElementById('stickyCta'),
      hero     = $('.f33-hero'),
      buybox   = d.getElementById('buybox'),
      finalCta = $('.f33-final-cta');

  if (sticky && hero && buybox && finalCta) {
    var toggleSticky = function(){
      var past = window.scrollY > (hero.offsetHeight + 80);
      var bb = buybox.getBoundingClientRect();
      var buyboxVisible = bb.top < window.innerHeight - 80 && bb.bottom > 80;
      var nearEnd = finalCta.getBoundingClientRect().top < window.innerHeight;
      sticky.classList.toggle('f33-show', past && !buyboxVisible && !nearEnd);
    };
    window.addEventListener('scroll', toggleSticky, { passive:true });
    window.addEventListener('resize', toggleSticky);
    toggleSticky();
  }

  /* ── Diagnostics ──────────────────────────────────────────────── */
  window.F33_DEBUG = function(){
    var out = {
      dataSource: dataSource,
      addMethod: ADD_METHOD,
      sellingPlansFound: plansFound,
      resolved: FLAVOURS,
      prices: { subscription: priceFor('sub'), oneTime: priceFor('onetime') },
      // If "code" is not what you expect for the country you're testing from,
      // the market/currency isn't switching — that's a Markets setting, not
      // this file. "sample" is what the buybox will actually print.
      currency: {
        code: MONEY_CODE,
        locale: MONEY_LOCALE,
        intl: !!moneyFormatter,
        shopifyGlobal: (window.Shopify && Shopify.currency) || null,
        sample: money(priceFor('sub'))
      },
      sellingPlanGroups: lastAjaxProduct ? (lastAjaxProduct.selling_plan_groups || []).map(function(g){
        return { name: g.name, plans: (g.selling_plans||[]).map(function(p){
          return { id: p.id, name: p.name };
        })};
      }) : 'product .js not loaded yet',
      cart: {
        zipifyApi: !!zipifyCart(),
        appDrawerPresent: !!appDrawer(),
        appDrawerOpen: appDrawerOpen(),
        themeDrawerOpen: themeDrawerIsOpen(),
        nativeCartDrawer: !!d.querySelector('cart-drawer'),
        triggerFound: (function(){
          var l = CART_TRIGGER ? d.querySelector(CART_TRIGGER) : d.querySelector(CART_LINK_SELECTORS);
          return l ? (l.tagName.toLowerCase() + (l.id ? '#'+l.id : '') +
                      (l.className ? '.'+String(l.className).trim().split(/\s+/).join('.') : '')) : null;
        })(),
        ocuElements: $$('[class*="ocu-"]').slice(0,15).map(function(el){
          return el.tagName.toLowerCase() +
                 (el.className ? '.'+String(el.className).trim().split(/\s+/).slice(0,3).join('.') : '');
        }),
        // Run F33_DEBUG() WHILE both drawers are open — whatever appears here
        // and is not an ocu-* element is the theme's drawer.
        openPanels: $$('body *').filter(function(el){
          var cs;
          try { cs = getComputedStyle(el); } catch(e){ return false; }
          if (cs.position !== 'fixed' && cs.position !== 'absolute') return false;
          if (cs.display === 'none' || cs.visibility === 'hidden') return false;
          if (parseFloat(cs.opacity || '1') < 0.1) return false;
          var r = el.getBoundingClientRect();
          if (r.width < 220 || r.height < 250) return false;
          if (r.right < 0 || r.left > window.innerWidth) return false;
          return true;
        }).slice(0, 12).map(function(el){
          return el.tagName.toLowerCase() +
                 (el.id ? '#' + el.id : '') +
                 (el.className ? '.' + String(el.className).trim().split(/\s+/).slice(0,4).join('.') : '');
        })
      }
    };
    console.log('%c[33Fuel LP] diagnostics', 'font-weight:bold;color:#339999');
    console.log(out);
    return out;
  };

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();